'use client'

import { RefObject, useEffect } from 'react'

export function useHtmlElementEvent<
  ElementEventKey extends keyof HTMLElementEventMap,
  ElementType extends HTMLElement,
>(
  eventKey: ElementEventKey,
  elementRef: RefObject<ElementType>,
  listener: (event: HTMLElementEventMap[ElementEventKey]) => unknown,
  { passive }: { passive: boolean } = { passive: false }
) {
  const element = elementRef.current
  useEffect(() => {
    element?.addEventListener(eventKey, listener, { passive })
    return () => element?.removeEventListener(eventKey, listener)
  }, [eventKey, element, listener, passive])
}
